import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { UnitImageCaptionDialogComponent } from './unit-image-caption-dialog.component';
import { FormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        UnitImageCaptionDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
    ],
    exports: [
        UnitImageCaptionDialogComponent,
    ],
    providers: [
    ],
})
export class UnitImageCaptionDialogModule
{
}
